import * as actionTypes from '../actions';
import {reduce} from 'ramda';

const initialState = {
    standardPlan: {
        planId: null,
        portfolioInfo: {
            begginingPortfolioValue: 100000.0,
            endingPortfolioValue: 19930498.0,
            averageReturns: 20.0,
            standardDeviation: 10.0,
            sharpeRatio: 2.0,
            sortinoRatio: 3.0
        },
        wealth: {
            percentile90: 19930498.0,
            percentile50: 19930498.0,
            percentile10: 19930498.0,
            percentile90Change: 0.0,
            percentile50Change: 0.0,
            percentile10Change: 0.0
        },
        wealthThreeYear: {
            percentile90: 19930498.0,
            percentile50: 19930498.0,
            percentile10: 19930498.0,
            percentile90Change: 0.0,
            percentile50Change: 0.0,
            percentile10Change: 0.0
        },
        allocation: {
            isDefault: true,
            allocationId: null,
            allocationName: "Default Allocation",
            invalid: false,
            editMode: false,
            assets: [
                {
                    assetId: 1,
                    name: "Category 1",
                    sortOrder: 1,
                    value: 20,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 2,
                    name: "Category 2",
                    sortOrder: 2,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 3,
                    name: "Category 3",
                    sortOrder: 3,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 4,
                    name: "Category 4",
                    sortOrder: 4,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        },
                        {
                            assetId: 6,
                            name: "Asset 6",
                            sortOrder: 6,
                            value: 0.0
                        }]
                },
                {
                    assetId: 5,
                    name: "Category 5",
                    sortOrder: 5,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                }
            ]
        },
        risk: {
            annualizedReturn: 15.0,
            risk: 5.0
        }
    },
    IP7Plan: {
        planId: null,
        portfolioInfo: {
            begginingPortfolioValue: 100000.0,
            endingPortfolioValue: 19430498.0,
            averageReturns: 20.0,
            standardDeviation: 10.0,
            sharpeRatio: 2.0,
            sortinoRatio: 3.0
        },
        wealth: {
            percentile90: 19930498.0,
            percentile50: 19930498.0,
            percentile10: 19930498.0,
            percentile90Change: 0.0,
            percentile50Change: 0.0,
            percentile10Change: 0.0
        },
        wealthThreeYear: {
            percentile90: 19930498.0,
            percentile50: 19930498.0,
            percentile10: 19930498.0,
            percentile90Change: 0.0,
            percentile50Change: 0.0,
            percentile10Change: 0.0
        },
        allocation: {
            isDefault: true,
            allocationId: null,
            allocationName: "Default Allocation",
            invalid: false,
            editMode: false,
            assets: [
                {
                    assetId: 1,
                    name: "Category 1",
                    sortOrder: 1,
                    value: 20,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 2,
                    name: "Category 2",
                    sortOrder: 2,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 3,
                    name: "Category 3",
                    sortOrder: 3,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                },
                {
                    assetId: 4,
                    name: "Category 4",
                    sortOrder: 4,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        },
                        {
                            assetId: 6,
                            name: "Asset 6",
                            sortOrder: 6,
                            value: 0.0
                        }]
                },
                {
                    assetId: 5,
                    name: "Category 5",
                    sortOrder: 5,
                    value: 20.0,
                    superAssetClassAlignment: "Left",
                    children: [
                        {
                            assetId: 1,
                            name: "Asset 1",
                            sortOrder: 1,
                            value: 10.0
                        },
                        {
                            assetId: 2,
                            name: "Asset 2",
                            sortOrder: 2,
                            value: 10.0
                        },
                        {
                            assetId: 3,
                            name: "Asset 3",
                            sortOrder: 3,
                            value: 0.0
                        },
                        {
                            assetId: 4,
                            name: "Asset 4",
                            sortOrder: 4,
                            value: 0.0
                        },
                        {
                            assetId: 5,
                            name: "Asset 5",
                            sortOrder: 5,
                            value: 0.0
                        }]
                }
            ]
        },
        risk: {
            annualizedReturn: 17.0,
            risk: 2.5
        }
    },
    conditions: {
        isMarket: true,
        equity: 3.0,
        interest: 3.0
    },
    lastConditions: {
        equity: 3.0,
        interest: 3.0
    },
    backupAllocation: {
        isDefault: true,
        allocationId: null,
        allocationName: "BACKUP Allocation",
        invalid: false,
        editMode: false,
        assets: [
            {
                assetId: -1,
                name: "Category 1",
                sortOrder: 1,
                value: 20,
                superAssetClassAlignment: "Left",
                children: [
                    {
                        assetId: -1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 10
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 10
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 2,
                name: "Category 2",
                sortOrder: 2,
                value: 20.0,
                superAssetClassAlignment: "Left",
                children: [
                    {
                        assetId: 1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 10.0
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 10.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 3,
                name: "Category 3",
                sortOrder: 3,
                value: 20.0,
                superAssetClassAlignment: "Left",
                children: [
                    {
                        assetId: 1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 10.0
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 10.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 4,
                name: "Category 4",
                sortOrder: 4,
                value: 20.0,
                superAssetClassAlignment: "Left",
                children: [
                    {
                        assetId: 1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 10.0
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 10.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            },
            {
                assetId: 5,
                name: "Category 5",
                sortOrder: 5,
                value: 20.0,
                superAssetClassAlignment: "Left",
                children: [
                    {
                        assetId: 1,
                        name: "Asset 1",
                        sortOrder: 1,
                        value: 10.0
                    },
                    {
                        assetId: 2,
                        name: "Asset 2",
                        sortOrder: 2,
                        value: 10.0
                    },
                    {
                        assetId: 3,
                        name: "Asset 3",
                        sortOrder: 3,
                        value: 0.0
                    },
                    {
                        assetId: 4,
                        name: "Asset 4",
                        sortOrder: 4,
                        value: 0.0
                    },
                    {
                        assetId: 5,
                        name: "Asset 5",
                        sortOrder: 5,
                        value: 0.0
                    }]
            }
        ]
    },
    downloadUrl: "",
    colors: [
        '#8bc445',
        '#cfe7b1',
        '#003399',
        '#0033cc',
        '#0066ff',
        '#A6A6A6',
    ]
};

let updateMarketConditionType = (state, isMarket) => {
    let newState = Object.assign({}, state);
    newState.conditions.isMarket = isMarket;
    return newState;
};

let updateConditionEquity = (state, equity) => {
    let newState = Object.assign({}, state);
    newState.conditions.equity = equity;
    return newState;
};

let updateConditionInterest = (state, interest) => {
    let newState = Object.assign({}, state);
    newState.conditions.interest = interest;
    return newState;
};

let updateIP7AllocationEditMode = (state, editMode) => {

    let newState = Object.assign({}, state);
    newState.IP7Plan.allocation.editMode = editMode;
    return newState;
};

let updateIP7AllocationValue = (state, data) => {
    let newState = Object.assign({}, state);

    let allocation = {
        isDefault: newState.IP7Plan.allocation.isDefault,
        allocationModelId: newState.IP7Plan.allocation.allocationModelId,
        allocationModelName: newState.IP7Plan.allocation.allocationModelName,
        invalid: newState.IP7Plan.allocation.invalid,
        editMode: newState.IP7Plan.allocation.editMode,
        assets: []
    };

    let assetList = newState.IP7Plan.allocation.assets;
    allocation.assets = assetList.map((category) => {
        if (category.assetId !== data.categoryId) return category;

        let newCategory = {
            assetId: category.assetId,
            name: category.name,
            value: 0.0,
            superAssetClassAlignment: "Left",
            children: []
        };

        newCategory.children = category.children.map((asset) => {
            if (asset.assetId !== data.assetId) return asset;
            let newAsset = {
                assetId: asset.assetId,
                name: asset.name,
                sortOrder: asset.sortOrder,
                value: 0.0
            };

            let assetValue = parseFloat(data.value);

            if (!isNaN(assetValue)) {
                newAsset.value = parseFloat(assetValue);
            } else {

                if (data.value !== "BLUR") newAsset.value = "";
                if (data.value === "BLUR" && asset.value === "") newAsset.value = 0.0;
                if (data.value === "BLUR" && asset.value !== "") newAsset.value = asset.value;
            }

            return newAsset;
        });

        let total = reduce((accum, asset) => {

            let newVal = parseFloat(asset.value);

            if (!isNaN(newVal)) {
                return accum + newVal;
            } else {
                return accum;
            }


        }, 0, newCategory.children);

        newCategory.value = total;

        return newCategory;
    });

    newState.IP7Plan.allocation = allocation;

    return newState;
};

let validateIP7Allocations = (state) => {
    let newState = Object.assign({}, state);
    newState.IP7Plan.allocation.invalid = false;

    // no allocation value can be negative
    // no negative values
    let allPositive = reduce((accum, category) => {

        let childAllValid = reduce((accum, asset) => {
            return accum && asset.value >= 0;
        }, true, category.children);

        return accum && childAllValid;

    }, true, newState.IP7Plan.allocation.assets);

    if (!allPositive) {
        newState.IP7Plan.allocation.invalid = true;
        return newState;
    }

    // allocation must always add to 100%
    let total = reduce( (accum, category) => {
        return accum + parseFloat(category.value);
    }, 0.0, newState.IP7Plan.allocation.assets);

    // bloody floats not playing nice
    if ( Math.abs(100.0 - total) > 0.01) {
        newState.IP7Plan.allocation.invalid = true;
    }


    return newState;
};


const updateStandardPlan = (state, data) => {

    let newState = Object.assign({}, state);

    newState.standardPlan.portfolioInfo.begginingPortfolioValue = data.beginningPortfolioValue.toFixed(0);
    newState.standardPlan.portfolioInfo.endingPortfolioValue = data.endingPortfolioValue.toFixed(0);
    newState.standardPlan.portfolioInfo.averageReturns = (data.averageReturn * 100).toFixed(2);
    newState.standardPlan.portfolioInfo.standardDeviation = (data.standardDeviation * 100).toFixed(2);
    newState.standardPlan.portfolioInfo.sharpeRatio = (data.sharpeRatio * 100).toFixed(2);
    newState.standardPlan.portfolioInfo.sortinoRatio = (data.sortinoRatio * 100).toFixed(2);

    newState.standardPlan.wealth.percentile90 = data.percentile90th.toFixed(0);
    newState.standardPlan.wealth.percentile50 = data.percentile50th.toFixed(0);
    newState.standardPlan.wealth.percentile10 = data.percentile10th.toFixed(0);

    newState.standardPlan.wealthThreeYear.percentile90 = data.percentile90thThirdYear.toFixed(0);
    newState.standardPlan.wealthThreeYear.percentile50 = data.percentile50thThirdYear.toFixed(0);
    newState.standardPlan.wealthThreeYear.percentile10 = data.percentile10thThirdYear.toFixed(0);

    newState.standardPlan.allocation = Object.assign({}, data.allocationModel);

    return newState;
};

function calculatePercentDifference(baseValue, targetValue) {
    let difference = targetValue - baseValue;
    let percentage = (difference / baseValue) * 100;
    return percentage.toFixed(2);
}

const updateIP7Plan = (state, data) => {
    let newState = Object.assign({}, state);

    newState.IP7Plan.portfolioInfo.begginingPortfolioValue = data.beginningPortfolioValue.toFixed(0);
    newState.IP7Plan.portfolioInfo.endingPortfolioValue = data.endingPortfolioValue.toFixed(0);
    newState.IP7Plan.portfolioInfo.averageReturns = (data.averageReturn * 100).toFixed(2);
    newState.IP7Plan.portfolioInfo.standardDeviation = (data.standardDeviation * 100).toFixed(2);
    newState.IP7Plan.portfolioInfo.sharpeRatio = (data.sharpeRatio * 100).toFixed(2);
    newState.IP7Plan.portfolioInfo.sortinoRatio = (data.sortinoRatio * 100).toFixed(2);


    newState.IP7Plan.wealth.percentile90 = data.percentile90th.toFixed(0);
    newState.IP7Plan.wealth.percentile50 = data.percentile50th.toFixed(0);
    newState.IP7Plan.wealth.percentile10 = data.percentile10th.toFixed(0);

    newState.IP7Plan.wealth.percentile90Change = calculatePercentDifference(newState.standardPlan.wealth.percentile90, newState.IP7Plan.wealth.percentile90);
    newState.IP7Plan.wealth.percentile50Change = calculatePercentDifference(newState.standardPlan.wealth.percentile50, newState.IP7Plan.wealth.percentile50);
    newState.IP7Plan.wealth.percentile10Change = calculatePercentDifference(newState.standardPlan.wealth.percentile10, newState.IP7Plan.wealth.percentile10);

    newState.IP7Plan.wealthThreeYear.percentile90 = data.percentile90thThirdYear.toFixed(0);
    newState.IP7Plan.wealthThreeYear.percentile50 = data.percentile50thThirdYear.toFixed(0);
    newState.IP7Plan.wealthThreeYear.percentile10 = data.percentile10thThirdYear.toFixed(0);

    newState.IP7Plan.wealthThreeYear.percentile90Change = calculatePercentDifference(newState.standardPlan.wealthThreeYear.percentile90, newState.IP7Plan.wealthThreeYear.percentile90);
    newState.IP7Plan.wealthThreeYear.percentile50Change = calculatePercentDifference(newState.standardPlan.wealthThreeYear.percentile50, newState.IP7Plan.wealthThreeYear.percentile50);
    newState.IP7Plan.wealthThreeYear.percentile10Change = calculatePercentDifference(newState.standardPlan.wealthThreeYear.percentile10, newState.IP7Plan.wealthThreeYear.percentile10);


    //newState.IP7Plan.allocation.assets = Array.from(data.allocationSorted);
    newState.IP7Plan.allocation = Object.assign({}, data.allocationModel);
    newState.IP7Plan.allocation.allocationModelName = "With Index Protector ";

    return newState;
};

const setStandardPlanId = (state, data) => {
    let newState = Object.assign({}, state);
    newState.standardPlan.planId = data;
    return newState;
};

const setIP7PlanId = (state, data) => {
    let newState = Object.assign({}, state);
    newState.IP7Plan.planId = data;
    return newState;
};

const resetMarketConditions = (state) => {
    let newState = Object.assign({}, state);
    newState.conditions = {
        isMarket: true,
        equity: 3.0,
        interest: 3.0
    };
    return newState;
};

const cancelIP7Changes = (state) => {
    let newState = Object.assign({}, state);

    newState.IP7Plan.allocation.assets = newState.backupAllocation.assets.map((element)=> {
        return element;
    });

    newState.IP7Plan.allocation.editMode = false;
    newState.IP7Plan.allocation.invalid = false;

    return newState;
};

const backupIP7Changes = (state) => {
    let newState = Object.assign({}, state);

    newState.backupAllocation.assets = newState.IP7Plan.allocation.assets.map((element) => {
        return element;
    });

    return newState;
};

const planOutputReducer = (state = initialState, action) => {
    if (action.type === actionTypes.UPDATE_MARKET_CONDITION_TYPE) {
        return updateMarketConditionType(state, action.isMarket);
    }

    if (action.type === actionTypes.UPDATE_CONDITION_EQUITY) {
        return updateConditionEquity(state, action.equity);
    }

    if (action.type === actionTypes.UPDATE_CONDITION_INTEREST) {
        return updateConditionInterest(state, action.interest);
    }

    if (action.type === actionTypes.SET_IP7_EDITABLE) {
        return updateIP7AllocationEditMode(state, true);
    }

    if (action.type === actionTypes.UPDATE_IP7_ALLOCATION) {
        return updateIP7AllocationValue(state, action.data);
    }

    if (action.type === actionTypes.SET_IP7_NONEDITABLE) {
        return updateIP7AllocationEditMode(state, false);
    }

    if (action.type === actionTypes.VALIDATE_IP7_ALLOCATIONS) {
        return validateIP7Allocations(state);
    }

    if (action.type === actionTypes.UPDATE_STANDARD_PLAN) {
        return updateStandardPlan(state, action.data);
    }

    if (action.type === actionTypes.UPDATE_IP7_PLAN) {
        return updateIP7Plan(state, action.data);
    }

    if (action.type === actionTypes.SET_STANDARD_PLANID) {
        return setStandardPlanId(state, action.data);
    }

    if (action.type === actionTypes.SET_IP7PLAN_PLANID) {
        return setIP7PlanId(state, action.data);
    }

    if (action.type === actionTypes.RESET_MARKET_CONDITIONS) {
        return resetMarketConditions(state);
    }

    if (action.type === actionTypes.SET_DOWNLOAD_URL) {
        let newState = Object.assign({}, state);
        newState.downloadUrl = action.data;
        return newState;
    }

    if (action.type === actionTypes.CANCEL_IP7_ALLOCATION_CHANGE) {
        return cancelIP7Changes(state);
    }

    if (action.type === actionTypes.SAVE_BACKUP_ALLOCATIONS) {
        return backupIP7Changes(state);
    }

    if (action.type === actionTypes.BACKUP_MARKET_CONDITIONS) {
        return {
            ...state,
            lastConditions: {
                interest: state.conditions.interest,
                equity: state.conditions.equity
            }
        }
    }

    return state;
};

export default planOutputReducer;





// WEBPACK FOOTER //
// ./src/store/reducers/planOutput.js